import React, { useContext, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../components/pages/MainLayout/index'; // Combines all sections
import Home from './pages/History';
import { runInAction } from "mobx";
import { adminRoutes, authRoutes, publicRoutes } from '../components/routes';
import { Context } from '..';
import { jwtDecode } from 'jwt-decode';
import Auth from './Auth';
import { observer } from 'mobx-react-lite';

const AppRouter = observer(() => {

    const { user } = useContext(Context);
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {

            try {
                runInAction(() => {
                    user.setIsAuth(true);
                });
                if (jwtDecode(token).role === 'ADMIN') {
                    user.setIsAdmin(true)
                }
            } catch (e) {
                console.error('Error setting auth state:', e);
            }
        } else {
            runInAction(() => {
                user.setIsAuth(false);
            });
        }
    }, [user]);
    return (
        <>
            <Routes>
                <Route path="/" element={<MainLayout />} />
                <Route path="/about" element={<MainLayout />} />
                <Route path="/" element={<MainLayout />} />
                <Route path="/" element={<MainLayout />} />
                <Route path="/" element={<MainLayout />} />
                <Route path="/" element={<MainLayout />} />
                <Route path="/" element={<MainLayout />} />
                <Route path="/history" element={<Home />} />
                <Route path='/' element={<MainLayout />} />
                {user.isAdmin ? (
                    adminRoutes.map(({ path, Component }) => (
                        <Route key={path} path={path} element={<Component />} />
                    ))
                ) : (
                    <Route path="/admin/*" element={<Auth />} replace />
                )}
                {user.isAuth && authRoutes.map(({ path, Component }) =>
                    <Route key={path} path={path} element={<Component />} exact />
                )}
                {publicRoutes.map(({ path, Component }) =>
                    <Route key={path} path={path} element={<Component />} />
                )}
                <Route path="*" element={<MainLayout />} />
            </Routes>
        </>
    );
});

export default AppRouter;
